import type { FC, JSX } from 'react';
import { BASE_URL } from '@/base/constants';
import { useIsDark } from '../theme/theme';

export const Logo: FC<
  Omit<JSX.IntrinsicElements['img'], 'src' | 'alt'> & {
    dark?: boolean;
    text?: boolean;
  }
> = ({ dark, text, ...props }) => {
  const isDark = useIsDark() || dark;
  const logoTypoFileName = isDark ? 'logo-typo-inverse' : 'logo-typo';
  const logoFileName = 'logo';

  return (
    <img
      src={`${BASE_URL}/${text ? logoTypoFileName : logoFileName}.svg`}
      alt="IQX Logo"
      fetchPriority="high"
      {...props}
    />
  );
};
